import { render, staticRenderFns } from "./DashBoardNeedList.vue?vue&type=template&id=0466746e&scoped=true"
import script from "./DashBoardNeedList.vue?vue&type=script&lang=js"
export * from "./DashBoardNeedList.vue?vue&type=script&lang=js"
import style0 from "./DashBoardNeedList.vue?vue&type=style&index=0&id=0466746e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466746e",
  null
  
)

export default component.exports